import './set-api.js'
import 'core-js/stable'
import { createApp } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'
import * as BVN from 'bootstrap-vue-next'
import axios from 'axios'
import App from './App.vue'
import router from './router.js'
import { routeParamsMixin } from './lib/route-helpers.js'
import { browserTimeZone } from '../../shared/app-timezone'
import { clearLoggedInUserForUrl } from './lib/live-user-storage'

axios.defaults.withCredentials = true

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {}
  config.headers['x-viewer-time-zone'] = browserTimeZone()
  return config
})

axios.interceptors.response.use((response) => response, (error) => {
  const data = error.response && error.response.data

  if (data && data.sessionEnded) {
    clearLoggedInUserForUrl(error.config && error.config.url)
    window.dispatchEvent(new CustomEvent('superturbo-session-ended', {
      detail: { reason: data.reason }
    }))
  }

  return Promise.reject(error)
})

import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import './page-column.css'

const app = createApp(App)
app.use(router)
app.use(createBootstrap())
app.mixin(routeParamsMixin)

// Register all bootstrap-vue-next components globally
// createBootstrap() only installs plugins (modal controller, toast, etc.)
// but does not register components in v0.24.x
const componentPrefix = /^B[A-Z]/
for (const [name, component] of Object.entries(BVN)) {
  if (componentPrefix.test(name) && typeof component === 'object' && component.setup) {
    app.component(name, component)
  }
}

app.mount('#app')
